import { render, staticRenderFns } from "./resign.vue?vue&type=template&id=5cccdae2&"
import script from "./resign.vue?vue&type=script&lang=js&"
export * from "./resign.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports